var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstadoAprobado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.65 108.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fffff4;\n      }\n\n      .cls-2 {\n        fill: #93a8ad;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m54.33,0C24.32,0,0,24.32,0,54.33s24.32,54.3,54.33,54.3,54.33-24.32,54.33-54.3S84.33,0,54.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.47,88.83l-24.96-31.08,8.99-7.22,14.48,18.03c4-6.74,8.09-13.46,12.2-20.07,5.7-9.15,11.61-18.33,17.57-27.29l9.6,6.38c-5.9,8.86-11.74,17.95-17.38,27-5.53,8.87-11,17.96-16.27,27l-4.22,7.24Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstadoAprobado);
export default __webpack_public_path__ + "static/media/EstadoAprobado.d00c2a27eb87f0edffb453935dd64228.svg";
export { ForwardRef as ReactComponent };